import {
  Component,
  OnInit,
  Attribute,
  AfterViewInit,
  HostListener,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router, RoutesRecognized } from "@angular/router";
import { SurveyService } from "../services/survey.service";
import { SurveyInfo } from "../models/surveyinfo.model";
import {
  SurveyQuestion,
  CheckboxOption,
  MultiTextInputOption,
} from "../models/survey-question.model";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { MatDialog } from "@angular/material/dialog";
import { MatRadioChange } from "@angular/material/radio";
import { MatSelectChange } from "@angular/material/select";
import { SaveSurveyEntry, Answer } from "../models/save-survey-entry.model";
import { ToastrWrapperService } from "../services/toastr-wrapper.service";
import { LocalstorageService } from "../services/localstorage.service";
import { UntypedFormControl, Validators } from "@angular/forms";
import { SuccessDialogComponent } from "../dialogs/success-dialog/success-dialog.component";
import { Observable, Subject } from "rxjs";
import { ComponentCanDeactivate } from "../services/component-can-deactivate";
import { SurveyResponse } from "../models/survey-response.model";
import { AuthDetails } from "../models/auth-details.model";
import { ScreeningReport } from "../models/screening-report.model";
import { filter, pairwise } from "rxjs/operators";
import { ErrorDialogComponent } from "../dialogs/error-dialog/error-dialog.component";
import { CameraService } from '../services/camera.service';
import { WebcamImage } from "ngx-webcam";
import { QuestionTranformationService } from "../services/question-tranformation.service";
import * as moment from "moment";
import { CovidTestData } from "../covid-test/covid-test.component";
import { ImageService } from "../services/image/image.service";
import { environment } from "../../environments/environment";

export interface ExternalTestData {
  surveyEntryId: number;
  nameOnTest: string;
  dateOfBirth: Date;
  testResult: string;
  testMethod: string;
  testDate: Date;
  files: any[];
}

@Component({
  selector: "app-survey",
  templateUrl: "./survey.component.html",
  styleUrls: ["./survey.component.css"],
})
export class SurveyComponent
  implements OnInit, AfterViewInit, ComponentCanDeactivate {
  @ViewChild('camera', { static: false }) camera;
  webCamImages: WebcamImage[] = []
  textInput = new UntypedFormControl("");
  dateInput = new UntypedFormControl("");

  title: string = "Just to Demo version number";
  //currentApplicationVersion: string = environment.appVersion;

  seasons: string[] = ["Winter", "Spring", "Summer", "Autumn"];
  surveyId: number;
  selectedSurveyInfo: SurveyInfo;
  questions: SurveyQuestion[] = [];

  selectedQuestionIndex = 0;
  currentQuestion: SurveyQuestion;
  isLoading = true;
  isSubmitting = false;
  surveyUrl: string;
  inputnumber: number;

  selectedHospital = "";
  formSubmitted = false;

  timeLeft: number = 10;

  screeningReportModel: ScreeningReport;
  screeningReport: true;
  previousUrl = "";

  // put resized images in their own array for async processing
  files = [];
  webCamfiles = [];
  covidTestDatafiles = [];

  readerFileDetails: string = "";

  allQuestions: SurveyQuestion[];

  isTeamMemberVaccinated: boolean = false;
  uploadUrl: string;
  isTeamMemberExempt: boolean = false;
  isTeamMemberVaccinatedInPast2Weeks: boolean = false;
  color: string = "black";
  weight: string = "normal";
  isVaxCardPendingApproval: any;
  isVaxCardRejected = false;
  nHEmployeeOrStudent: any;
  lastCovidTest8DaysOrMore: any;
  covidTestData: CovidTestData = undefined;
  selectedCardImageOptionText: string;
  corpId: string;
  isFirstAgTest: boolean;
  isTMBoostedMoreThan14Days: any;
  isTMValidated: boolean;
  isLastPSSResultFail: boolean;
  isTMContractor: boolean;
  isExposureReportedInLast7Days: any;
  isBoosterUpToDate: boolean;
  lastExposureReport: any;
  lastDoseGreaterThan6Months: boolean;
  newEvent: boolean = false;
  @HostListener("window:beforeunload")
  canDeactivate(): boolean {
    if (this.surveyUrl == '/survey/covidexposuretestupload') return true;
    let isDirty = this.questions.some((q) => q.answerText != ""); //some of the question is filled in
    return !isDirty || this.formSubmitted;
  }
  externalTestData: ExternalTestData;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private surveyService: SurveyService,
    private toasterWrapper: ToastrWrapperService,
    private router: Router,
    private localstorageService: LocalstorageService,
    private cameraService: CameraService,
    private imageService: ImageService,
    private questionTranformationService: QuestionTranformationService
  ) { }

  async ngOnInit() {
    //this.surveyUrl = this.route.snapshot.paramMap.get("url");

    this.covidTestData = undefined;
    this.surveyUrl = this.router.url;
    console.log(this.surveyUrl);

    if (this.surveyUrl == "/screening/pre-shift" || this.surveyUrl == "/survey/vaxupload") {
      this.webCamImages = [];
      await this.isVerified();
    }

    if (this.surveyUrl == "/survey/covidexposure") {
      let authDetails = this.getAuth();
      if (authDetails != null) {
        this.corpId = authDetails.employeeInfo.corpId;
      }
      const { isFirstAgTest, isTMBoostedMoreThan14Days, isTMVaccinated, isExposureReportedInLast7Days, isTMContractor } = await this.surveyService.getExposureDetails(this.corpId).toPromise();
      this.isFirstAgTest = isFirstAgTest;
      this.isTMBoostedMoreThan14Days = isTMBoostedMoreThan14Days;
      this.isTeamMemberVaccinated = isTMVaccinated;
      this.isExposureReportedInLast7Days = isExposureReportedInLast7Days;
      this.isTMContractor = isTMContractor;
      this.isTMValidated = this.localstorageService.isAuthenticated();
      let lastScreeningReport = await this.surveyService.getScreeningReport(this.corpId).toPromise();
      if (lastScreeningReport) {
        this.isLastPSSResultFail = lastScreeningReport.resultType == 'Fail';
      }
      console.log({ isFirstAgTest, isTMBoostedMoreThan14Days, isTMVaccinated, isTMContractor });
    }

    if (this.surveyUrl == '/survey/covidexposuretestupload') {
      let exposureAuth = this.getAuth();
      if (exposureAuth != null) {
        this.corpId = exposureAuth.employeeInfo.corpId;
      }
      this.lastExposureReport = await this.surveyService.getExposureReportedInLast7Days(this.corpId).toPromise();
      console.log(this.lastExposureReport)
    }

    this.getSurveyInfo();
  }

  onSelectFile(event) { // called each time file input changes
    console.log('onSelectFile', event);

    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event) => { // called once readAsDataURL is completed
        //console.log('reader.result', reader.result.toString());
        if (reader.result.toString().includes("image") || reader.result.toString().includes("application/pdf")) {
          //this.uploadUrl = reader.result.toString();
          //this.readerFileDetails = reader.result.toString();
          this.color = "black";
          this.weight = "normal";
          this.currentQuestion.answerText = "Yes";
          // only resize images
          if (reader.result.toString().includes("image")) {
            this.imageService.resizeImage(reader.result.toString(), 1000, 1000).then(data => {
              this.readerFileDetails = data;
              this.uploadUrl = this.readerFileDetails;
              console.log('this.readerFileDetails', this.readerFileDetails);
            });
          }
          else {
            this.files.push(reader.result);
            this.readerFileDetails = this.files.toString();
          }
        }
        else {
          this.color = "red";
          this.weight = "bold";
          this.uploadUrl = "";
          this.readerFileDetails = "";
          this.currentQuestion.answerText = "";
        }
      }
    }
  }

  handleImage(pictures) {
    this.currentQuestion.answerText = "Yes";
    this.webCamfiles = [];
    //this.webCamImages = pictures;
    pictures.forEach(p => {
      this.imageService.resizeImage(p.imageAsDataUrl, 1000, 1000).then(data => {
        this.webCamfiles.push(data);
      });

    });
  }

  handleCovidTestData(covidTestData) {
    console.log('handleCovidTestData', covidTestData);
    this.covidTestData = covidTestData;
    this.currentQuestion.answerText = covidTestData.resultAnswerText;
  }

  handleExternalUploadData(externalUpload) {
    console.log('externaUpload', externalUpload);
    this.externalTestData = externalUpload;
    this.currentQuestion.answerText = 'Yes';
    this.updateQuestions();
    if (this.surveyUrl == '/survey/covidexposuretestupload') {
      this.nextQuestion();
    }
    else {
      this.disableContinueBtn();
    }
  }

  saveUploadImages(result) {
    this.files.push(result.toString());
    return this.cameraService.savePhoto(this.files);
  }

  getSurveyInfo() {
    this.surveyService.getSurveyInfos().subscribe((list) => {
      this.selectedSurveyInfo = list.find(
        (s) => s.surveyUrl == this.surveyUrl.toLowerCase()
      );

      this.surveyId = this.selectedSurveyInfo.surveyAppId;

      console.log(this.selectedSurveyInfo);
      this.isLoading = true;

      this.surveyService.getSurveyQuestions(this.surveyId).subscribe((responseData) => {
        this.questions = responseData.filter((r) => r.decisionFieldName == null);

        if (this.surveyUrl == "/survey/covidexposure") {
          this.questions = this.questions.filter(q=>q.sectionName == 'InitialFlow');
          if (this.isLastPSSResultFail) {
            this.questions = this.questions.filter((r) => r.decisionResponse == 'LastScreeningFail' || r.decisionResponse == null);
          }
          else{
            this.questions = this.questions.filter((r) => r.decisionResponse == 'LastScreeningFailNo' || r.decisionResponse == null);
          }
        }

        //this.remQuestion = this.questions.splice(3, this.questions.length);
        responseData.forEach(q => {
          q.questionText = this.questionTranformationService.replaceQuestionText(q.questionText, q.questionFieldName);
          if (q.questionFieldName == 'ExtUploadExposureReported' && this.lastExposureReport.enteredDateTime) {
            q.questionText = q.questionText.replace('<Date>', this.lastExposureReport.enteredDateTime);
          }
          //if (q.questionFieldName == 'PreScreenPositiveCovid') {
          //  let tempTypes = ["VaxExempt", "FullyVaccinated", "VaccinatedInPast2Weeks", "VaxCardRejected"];
          //  let fullyVaccinatedOptions = q.options.filter(o => tempTypes.indexOf(o.optionId) >= 0);
          //  let tempOptions = q.options.filter(o => !(tempTypes.concat("No").indexOf(o.optionId) >= 0));
          //  let noOption = q.options.filter(o => o.optionId == "No");
          //  if (fullyVaccinatedOptions.length > 0) {
          //    // if (this.isTeamMemberVaccinated) {
          //    //   q.options = tempOptions.concat(fullyVaccinatedOptions.filter(o => o.optionId == "FullyVaccinated"));
          //    // }
          //    // else
          //    if (this.isTeamMemberVaccinatedInPast2Weeks) {
          //      q.options = tempOptions.concat(fullyVaccinatedOptions.filter(o => o.optionId == "VaccinatedInPast2Weeks"));
          //    }
          //    else if (this.isVaxCardRejected) {
          //      q.options = tempOptions.concat(fullyVaccinatedOptions.filter(o => o.optionId == "VaxCardRejected"));
          //    }
          //    else {
          //      q.options = tempOptions.concat(noOption);
          //    }
          //  }
          //}
          if (q.questionFieldName == 'PreScreen-MaskReminder') {
            q.options.forEach(o => {
              if (this.isVaxCardRejected) {
                o.optionId = "VaxCardRejected"
              }
              else if (this.lastDoseGreaterThan6Months) {
                o.optionId = "LastDoseGreaterThan6MonthsYes"
              }
              else{
                o.optionId = "LastDoseGreaterThan6MonthsNo"
              }
              // else if (this.isTeamMemberVaccinatedInPast2Weeks) {
              //   o.optionId = "VaccinatedInPast2Weeks"
              // }
            });
          }
          if (q.questionFieldName == 'PreScreenClearedToReturnSymptoms') {
            this.isTeamMemberVaccinated = true; //hard setting this to "true" for flow change because this question is for cleared symptons even for vaccinated and unvaccinated TM's
            let tempTypes = ["VaxExempt", "FullyVaccinated", "VaccinatedInPast2Weeks", "VaxCardRejected"];
            let fullyVaccinatedOptions = q.options.filter(o => tempTypes.indexOf(o.optionId) >= 0);
            let tempOptions = q.options.filter(o => !(tempTypes.concat("No").indexOf(o.optionId) >= 0));
            let noOption = q.options.filter(o => o.optionId == "No");
            if (fullyVaccinatedOptions.length > 0) {
              if (this.isTeamMemberVaccinated) {
                q.options = tempOptions.concat(fullyVaccinatedOptions.filter(o => o.optionId == "FullyVaccinated"));
              }
              else if (this.isTeamMemberVaccinatedInPast2Weeks) {
                q.options = tempOptions.concat(fullyVaccinatedOptions.filter(o => o.optionId == "VaccinatedInPast2Weeks"));
              }
              else if (this.isVaxCardRejected) {
                q.options = tempOptions.concat(fullyVaccinatedOptions.filter(o => o.optionId == "VaxCardRejected"));
              }
              else {
                q.options = tempOptions.concat(noOption);
              }
            }
          }
          if (q.questionFieldName == 'PreScreenVaxCardImage' || q.questionFieldName == 'PreScreenVaxCardImageClearedToReturn') {
            console.log('PreScreenVaxCardImageClearedToReturn');
            q.options.forEach(o => {
              if (o.optionId == "Yes" && this.isVaxCardPendingApproval) {
                o.optionId = "VaxCardPendingApproval"
              }
              if (o.optionId == "No" && this.isTeamMemberExempt) {
                o.optionId = "VaxExempt"
              }
            });
          }
          if (q.questionFieldName == 'PreScreenVaxCardRejected') {
            q.options.forEach(o => {
              if (o.optionId == "No" && this.isVaxCardRejected) {
                o.optionId = "VaxCardRejected"
              }
            });
          }
          // if (q.questionFieldName == 'PreScreen-Vaccine') {
          //   console.log('PreScreen-Vaccine');
          //   q.options.forEach(o => {
          //     if (o.optionId == "No") {
          //       if (this.isTeamMemberVaccinated) {
          //         o.optionId = "FullyVaccinated"
          //       }
          //       else if (this.isTeamMemberVaccinatedInPast2Weeks) {
          //         o.optionId = "VaccinatedInPast2Weeks";
          //       }
          //       else {
          //         if (this.nHEmployeeOrStudent) {
          //           if (this.lastCovidTest8DaysOrMore) {
          //             o.optionId = "LastCovidTest8DaysOrMoreYes"
          //           }
          //           else {
          //             o.optionId = "LastCovidTest8DaysOrMoreNo"
          //           }
          //         }
          //       }
          //     }
          //     else {
          //       if (this.nHEmployeeOrStudent && !this.isTeamMemberVaccinated) {
          //         o.optionId = "CovidTestNotReq"
          //       }
          //     }
          //   });
          // }

          if (q.questionFieldName == 'CovidExposure90DaysPositiveCovid') {
            q.options.forEach(o => {
              if (o.optionId == "No" && this.isTeamMemberVaccinated) {
                o.optionId = "Vaccinated"
              }
            });
          }

          //if (q.questionFieldName == 'CovidExposureBoosterDose') {
          //  q.options.forEach(o => {
          //    if (o.optionId == "No" && this.isTeamMemberVaccinated) {
          //      o.optionId = "Vaccinated"
          //    }
          //  });
          //}

          // if (q.questionFieldName == 'CovidExposureBoosterSymptoms'
          //   || q.questionFieldName == 'CovidExposureGeneralSymptoms'
          //   || q.questionFieldName == 'CovidExposureVaxSymptoms') {
          //   q.options.forEach(o => {
          //     if (o.optionId == "Yes" && this.isExposureReportedInLast7Days) {
          //       o.optionId = "ExposureReportedInLast7DaysYes"
          //     }
          //   });
          // }

          //if (q.questionFieldName == 'CovidExposureInternationTravel') {
          //  q.options.forEach(o => {
          //    if (o.optionId == "Yes" && this.isTeamMemberVaccinated) {
          //      o.optionId = "Vaccinated"
          //    }
          //    else if (o.optionId == "Yes" && !this.isTMValidated) {
          //      o.optionId = "NotValidated"
          //    }
          //    else if (o.optionId == "Yes" && !this.isTeamMemberVaccinated) {
          //      o.optionId = "NotVaccinated"
          //    }
          //  });
          //}

          //if (q.questionFieldName == 'CovidExposureBoosterDose') {
          //  q.options.forEach(o => {
          //    if (o.optionId == "Yes") {
          //      this.isBoosterUpToDate = true;
          //    }
          //    else {
          //      this.isBoosterUpToDate = false;
          //    }
          //  });
          //}

          //if (q.questionFieldName == 'CovidExposureInternationTravel') {
          //  q.options.forEach(o => {
          //    if (o.optionId == "Yes" && !this.isBoosterUpToDate) {
          //      o.optionId = "BoosterNotUpToDate";
          //    }
          //    //if (o.optionId == "Yes" && !this.isBoosterUpToDateFromPrevQuestion) {
          //    //  o.optionId = "BoosterNotUpToDate";
          //    //}
          //  });
          //}

          if (q.questionFieldName == 'CovidExposureCruise14Days') {
            q.options.forEach(o => {
              if (o.optionId == "Yes" && this.isTeamMemberVaccinated) {
                o.optionId = "Vaccinated"
              }
              else if (o.optionId == "Yes" && !this.isTMValidated) {
                o.optionId = "NotValidated"
              }else if (o.optionId == "Yes" && !this.isTeamMemberVaccinated) {
                o.optionId = "NotVaccinated"
              }
            });
          }
          if (q.questionFieldName == 'ExtUploadPartnerSite') {
            q.options.forEach(o => {
              if (o.optionId == "No" && this.lastExposureReport.enteredDateTime) {
                o.optionId = "ExposureReported"
              }
            });
          }
        });
        this.allQuestions = [...responseData];
        console.log(this.allQuestions);
        this.currentQuestion = this.questions[this.selectedQuestionIndex];
        this.addValidations();
        this.isLoading = false;
        //this.toasterWrapper.showSuccess('Loaded data successfully');
        console.log(this.questions);
      }, (error) => {
        if (!navigator.onLine) {
          let transSaveErrorMessage = "Connection Error";
          var onlineErrorMsg = "Unable to determine a result at this time.This is usually the result of an internet connectivity issue.Would you like to submit your answers again or start the screening again?"
          this.openErrorDialog(transSaveErrorMessage, onlineErrorMsg);
        }
        else {
          this.toasterWrapper.showError(JSON.stringify(error));
        }
      });
    }, (error) => {
      if (!navigator.onLine) {
        let transSaveErrorMessage = "Connection Error";
        var onlineErrorMsg = "Unable to determine a result at this time.This is usually the result of an internet connectivity issue.Would you like to submit your answers again or start the screening again?"
        this.openErrorDialog(transSaveErrorMessage, onlineErrorMsg);
      }
      else {
        this.toasterWrapper.showError(JSON.stringify(error));
      }
    });
  }

  async isVerified() {
    let authDetails = this.getAuth();
    if (authDetails == undefined) return;

    this.corpId = authDetails.employeeInfo.corpId;
    var url = this.getPreviousURL();
    const newScreeningReport = this.localstorageService.getItem("newScreeningReport");
    const hasScreeningReport = this.localstorageService.getItem("screeningReport");

    // if (localStorage.getItem("previousUrl") !== "/screening-report") {

    await this.isNewEvent();

    console.log('Navigate Info: ', newScreeningReport, this.newEvent);
    if (!newScreeningReport && !this.newEvent) {
      this.surveyService
        .getScreeningReport(authDetails.employeeInfo.corpId)
        .subscribe(
          (responseData) => {
            this.screeningReportModel = responseData;
            this.timeLeft = Math.floor(this.screeningReportModel.timeLeft);
            if (this.timeLeft > 1) {
              this.router.navigateByUrl("/screening-report");
            }
          },
          (error) => console.log(error)
        );
    }

    this.isTeamMemberVaccinated = await this.surveyService.isTeamMemberVaccinated(authDetails.employeeInfo.corpId).toPromise();
    const { isExempt, vaccinatedInPast2Weeks, vaxCardPendingApproval, vaxCardRejected, nhEmployeeOrStudent, lastCovidTest8DaysOrMore, lastDoseGreaterThan6Months } = await this.surveyService.getVaxDetails(authDetails.employeeInfo.corpId).toPromise();
    this.isTeamMemberExempt = isExempt;
    this.isTeamMemberVaccinatedInPast2Weeks = vaccinatedInPast2Weeks;
    this.isVaxCardPendingApproval = vaxCardPendingApproval;
    this.isVaxCardRejected = vaxCardRejected;
    this.nHEmployeeOrStudent = nhEmployeeOrStudent;
    this.lastCovidTest8DaysOrMore = lastCovidTest8DaysOrMore;
    this.lastDoseGreaterThan6Months = lastDoseGreaterThan6Months;
    console.log('fullyvaccinated', this.isTeamMemberVaccinated,
      'exempt ', this.isTeamMemberExempt,
      'VaccinatedInPast2Weeks', this.isTeamMemberVaccinatedInPast2Weeks);
    //load text replacements from database
    await this.questionTranformationService.loadDynamicQuestionTexts(authDetails.employeeInfo.corpId);

  }

  async isNewEvent() {
    let authDetails = this.getAuth();
    if (authDetails == undefined) return false;

    let eventDisplayName = '';

    (await this.surveyService.getEventDisplayName(authDetails.employeeInfo.corpId)).toPromise().then(response => {
      eventDisplayName = response.displayName;
    });

    let currentEvent = this.surveyService.locationOrEvent.event;

    if (currentEvent != null && currentEvent !== '') {
      await (await this.surveyService.getEventDetails(currentEvent)).toPromise().then(event => {
        let currentEventDisplayName = event.displayName;
        if (eventDisplayName !== currentEventDisplayName) {
          this.newEvent = true;
        }
        else
          this.newEvent = false;
      })
    }
    else {
      this.newEvent = false;
    }
  }

  getPreviousURL(): Observable<string> {
    let url;
    var subject = new Subject<string>();
    this.router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((events: RoutesRecognized[]) => {
        if (
          typeof events[0].urlAfterRedirects !== "undefined" &&
          events[0].urlAfterRedirects !== ""
        ) {
          url = events[0].urlAfterRedirects;
          localStorage.setItem("previousUrl", url);
        }
      });
    return subject.asObservable();
  }

  getAuth(): AuthDetails {
    return JSON.parse(localStorage.getItem("auth"));
  }

  ngAfterViewInit() {
    if (this.localstorageService.showConfirmDialog == true) {
      let authDetails = this.localstorageService.getAuth();
      const dialogRef = this.dialog.open(SuccessDialogComponent, {
        width: "450px",
        data: authDetails.employeeInfo,
      });

      dialogRef.afterClosed().subscribe((result) => {
        console.log("The dialog was closed", result);
        if (result == "continue") {
          this.localstorageService.showConfirmDialog = false;
        } else {
          this.localstorageService.removeAuth();
          this.router.navigateByUrl("/verify");
        }
      });
    }
  }

  getTextInputErrorMessage() {
    if (this.currentQuestion) {
      if (this.currentQuestion.dataTypeName == 'text' || this.currentQuestion.dataTypeName == 'number')
        return this.textInput.hasError("required")
          ? "You must enter a value" : this.textInput.hasError("pattern")
            ? this.getFieldSpecificErrorMessage()
            : "";
    }

    return "";
  }

  getDateInputErrorMessage() {
    if (this.currentQuestion) {
      if (this.currentQuestion.dataTypeName == 'date')
        return this.dateInput.hasError("required")
          ? "You must enter a value" : this.dateInput.hasError("matDatepickerMin")
            ? "Invalid minimum date" : this.dateInput.hasError("matDatepickerMax")
              ? "Invalid maximum date" : this.dateInput.hasError("matDatepickerParse")
                ? "Invalid date"
            : "";
    }

    return "";
  }

  formControlsInvalid() {
    if (this.currentQuestion) {
      if (this.currentQuestion.dataTypeName == 'date') {
        return this.dateInput.invalid;
      }
      if (this.currentQuestion.dataTypeName == 'text' || this.currentQuestion.dataTypeName == 'number') {
        return this.textInput.invalid;
      }
    }
  }

  getFieldSpecificErrorMessage() {
    if (this.currentQuestion.validations == 'PhoneNumber')
      return "Please enter 10 digit phone number"
    if (this.currentQuestion.validations == 'Email')
      return "Please enter a valid email address"
  }

  disableContinueBtn() {
    //console.log("validations: " + this.currentQuestion.validations);
    if (this.currentQuestion.validations != '' && this.getTextInputErrorMessage().length > 0 && this.getDateInputErrorMessage().length > 0) {
      console.log('DateInputErrorMessage: ', this.getDateInputErrorMessage());
      return true;
    }

    if (this.selectedQuestionIndex == this.questions.length - 1 || (this.currentQuestion.required && this.currentQuestion.answerText == ''))
      return true;

    if (this.currentQuestion.dataTypeName == 'date' && this.currentQuestion.answerText == null)
      return true;

    return false;
  }

  disableSubmitBtn() {
    if (this.isSubmitting)
      return true;

    if (this.currentQuestion.validations != '' && this.getTextInputErrorMessage().length > 0 && this.getDateInputErrorMessage().length > 0)
      return true;

    if (this.currentQuestion.required && this.currentQuestion.answerText == '')
      return true;

    if (this.currentQuestion.dataTypeName == 'date' && this.currentQuestion.answerText == null)
      return true;

    return false;
  }

  remQuestion: SurveyQuestion[];
  get progressBar() {
    this.updateQuestions();
    if (this.questions.length - 1 == this.selectedQuestionIndex) return 100;

    return (100 / this.questions.length) * this.selectedQuestionIndex;
  }

  sections = [
    { questionFieldName: "CovidExposureDatePostiveTest", answer: "**", sectionName: "Check for Symptoms" },
    { questionFieldName: "CovidExposureTestedPositive", answer: "|No|", sectionName: "Check for Symptoms" },
    { questionFieldName: "CovidExposureSymptomStartDate", answer: "**", sectionName: "Sx and/or COVID+ International Travelers" },
    { questionFieldName: "CovidExposureGeneralSymptoms", answer: "|No|", sectionName: "**" },
    { questionFieldName: "CovidExposureVaxSymptoms", answer: "|No|", sectionName: "**" },
    { questionFieldName: "CovidExposureBoosterSymptoms", answer: "|No|", sectionName: "**" },
    { questionFieldName: "PositiveTestExposureSymptomDate", answer: "**", sectionName: "Gather Personal Information"},
    { questionFieldName: "CovidExposureSourceDD", answer: "|No known exposure|", sectionName: "Gather Personal Information"},
    { questionFieldName: "CovidExposureBoosterCruise14Days", answer: "|No|", sectionName: "COVID-19 Intake"},
    { questionFieldName: "CovidExposureBoosterIntTravelDate", answer: "**", sectionName: "COVID-19 Intake"},
    { questionFieldName: "CovidExposureFullyVaccinated", answer: "|Yes|", sectionName: "International Travel Intake"},
    { questionFieldName: "CovidExposureCruise14Days", answer: "|Vaccinated|", sectionName: "International Travel Intake"},
    { questionFieldName: "CovidExposureInternationTravel", answer: "|Vaccinated|", sectionName: "International Travel Intake"},
    { questionFieldName: "CovidExposureCruise14Days", answer: "|No|", sectionName: "Exposure Processing"},
    { questionFieldName: "PositiveTestExposureSymptomDate", answer: "**", sectionName: "Gather Personal Information"},
    { questionFieldName: "CovidExposureSourceDD", answer: "|No known exposure|", sectionName: "Gather Personal Information"},
    { questionFieldName: "CovidExposureIntRequiredTest", answer: "|OK|", sectionName: "Gather Personal Information"},
    { questionFieldName: "CovidExposureCDCGuideline", answer: "|OK|", sectionName: "COVID-19 Intake"},
    { questionFieldName: "CovidExposureExposedDate", answer: "**", sectionName: "Gather Personal Information"},
    { questionFieldName: "CovidExposureSourceDD48Hours", answer: "|No Known Exposure|", sectionName: "Gather Personal Information"},
    { questionFieldName: "CovidExposureUploadFileInput", answer: "**", sectionName: "Check for Symptoms"},
    { questionFieldName: "CovidExposureDatePostiveTest", answer: "**", sectionName: "Check for Symptoms"},
  ]
  updateQuestions() {
    if (this.allQuestions === undefined) return;

    //console.log('Questions start: ', this.questions);

    let decisiontQuestions: SurveyQuestion[] = [];
    let sectionQuestions: SurveyQuestion[] = [];
    if (this.surveyUrl == '/survey/covidexposure') {
      let foundSection = this.sections.find(s => s.questionFieldName == this.currentQuestion.questionFieldName
        && (s.answer.indexOf('|' + this.currentQuestion.answerText + '|') >= 0 || s.answer == '**'));


      if (foundSection) {
        if (foundSection.sectionName == '**') {
          if (this.isPositiveCovid19TestFromPrevQuestion == false && this.isLastPSSResultFail == false
            && this.currentQuestion.questionFieldName == 'CovidExposureBoosterSymptoms'
            && this.currentQuestion.answerText == 'No') {
            //return; // additional question is not needed. exit from here
            //console.log('Found Section = International Travel Intake');
            foundSection.sectionName = "International Travel Intake";
          }
          if (this.isPositiveCovid19TestFromPrevQuestion == true || this.isLastPSSResultFail == true) {
            foundSection.sectionName = "Sx and/or COVID+ International Travelers";
          }
          else {
            foundSection.sectionName = "Asymptomatic International Travelers";
          }
        }
        if(foundSection.sectionName == 'Check for Symptoms'){
          if(this.isLastPSSResultFail){
            sectionQuestions = this.allQuestions.filter(q=>q.questionFieldName == 'CovidExposureBoosterSymptoms');
          }
          //else if(this.isTMBoostedMoreThan14Days){
          //  sectionQuestions = this.allQuestions.filter(q=>q.questionFieldName == 'CovidExposureBoosterSymptoms');
          //}
          else{
            sectionQuestions = this.allQuestions.filter(q => q.questionFieldName == 'CovidExposureBoosterDose');
          }
        }
        else {
          sectionQuestions = this.allQuestions.filter((r) => r.decisionFieldName == null && r.sectionName == foundSection.sectionName);
        }
        //console.log('section questions', sectionQuestions);
      }
      decisiontQuestions = this.allQuestions.filter((a) =>
        a.decisionFieldName == this.currentQuestion.questionFieldName &&
        a.decisionResponse.indexOf('|' + this.currentQuestion.answerText + '|') >= 0
        // && a.sectionName == this.currentQuestion.sectionName
      );
      //find section setup
      if (sectionQuestions.length > 0) {
        decisiontQuestions.push(...sectionQuestions);
      }
      if (this.currentQuestion.questionFieldName == 'CovidExposureLastOnsite' && this.isTMContractor) {
        decisiontQuestions.push(this.allQuestions.find((a) =>
          a.decisionFieldName == '**' && a.decisionResponse == '|TMIsContractor|')
        )
      }
      if (this.currentQuestion.questionFieldName == 'CovidExposureIntTravelDate') {
        decisiontQuestions.push(this.allQuestions.find((a) => a.questionFieldName == 'CovidExposureIntRequiredTest'));
        //if (!this.isBoosterUpToDateFromPrevQuestion) {
        //  //console.log('Add CovidExposureCDCGuideline');
        //  decisiontQuestions.push(this.allQuestions.find((a) => a.questionFieldName == 'CovidExposureCDCGuideline'));
        //}
        //else {
        //  //console.log('Add CovidExposureIntRequiredTest')
        //  decisiontQuestions.push(this.allQuestions.find((a) => a.questionFieldName == 'CovidExposureIntRequiredTest'));
        //}
      }
    }
    else {
      decisiontQuestions = this.allQuestions.filter((a) =>
       a.decisionFieldName == this.currentQuestion.questionFieldName && a.decisionResponse == this.currentQuestion.answerText);
    }
    let quetionsAlreadyAdded = this.questions.filter((q) => q.decisionFieldName == this.currentQuestion.questionFieldName);
    //console.log('already', quetionsAlreadyAdded);

    if (quetionsAlreadyAdded.length > 0 && quetionsAlreadyAdded[0].decisionResponse != this.currentQuestion.answerText) {
      //need to remove already added questions
      // let prevQuestionCount = this.questions.slice(this.selectedQuestionIndex + quetionsAlreadyAdded.length, this.questions.length)
      //                         .filter((q) => q.decisionFieldName != null).length;
      this.questions.splice(this.selectedQuestionIndex + 1, this.questions.length - this.selectedQuestionIndex);
    }

    if (decisiontQuestions.length > 0) {
      const found = this.questions.some((r) => decisiontQuestions.includes(r));
      if (!found) {
        this.questions.splice(this.selectedQuestionIndex + 1, 0, ...decisiontQuestions);
      }

    }

    //check if null decision field are there
    if (this.surveyUrl == "/screening/pre-shift") {
      let nullQuestionToAdd = [];
      let decisionFieldNullQuestions = this.allQuestions.filter((a) => a.decisionFieldName == null && a.sortOrder > this.currentQuestion.sortOrder);
      decisionFieldNullQuestions.forEach(d => {
        if (this.questions.find(q => q.questionFieldName == d.questionFieldName) == undefined) {
          nullQuestionToAdd.push({ ...d })
        }
      })
      if (nullQuestionToAdd.length > 0) {
        this.questions.splice(this.selectedQuestionIndex + 1, 0, ...nullQuestionToAdd);
        console.log('adding null questions', nullQuestionToAdd)
      }
    }
    //console.log('Questions end: ', this.questions);
  }

  get isPositiveCovid19TestFromPrevQuestion(){


    let foundQuestion = this.questions.find(q => q.questionFieldName == 'CovidExposureTestedPositive');
    if(foundQuestion && foundQuestion.answerText == 'Yes'){
      return true;
    }

    return false;
  }

  get isBoosterUpToDateFromPrevQuestion() {
    let foundQuestion = this.questions.find(q => q.questionFieldName == 'CovidExposureBoosterDose');
    //console.log('BoosterUpToDate: ', foundQuestion);
    if (foundQuestion && foundQuestion.answerText == 'Yes') {
      return true;
    }
    return false;
  }

  setSelectedIndex(index: number) {
    this.selectedQuestionIndex = index;
    this.currentQuestion = this.questions[this.selectedQuestionIndex];
  }

  prevQuestion() {
    this.selectedQuestionIndex--;
    this.setSelectedIndex(this.selectedQuestionIndex);
    console.log(this.currentQuestion);
    console.log(this.questions);
    this.addValidations();
  }

  maxDate = new Date(2050, 1, 1);
  minDate = new Date(2020, 1, 1);

  nextQuestion() {
    this.textInput = new UntypedFormControl("");
    this.dateInput = new UntypedFormControl("");

    this.selectedQuestionIndex++;
    this.setSelectedIndex(this.selectedQuestionIndex);
    console.log("CurrentQuestion: ", this.currentQuestion);
    console.log("Question", this.questions);
    this.addValidations();
  }

  addValidations() {
    let validators = [];
    if (this.currentQuestion.required)
      validators.push(Validators.required);
    if (this.currentQuestion.validations == 'PhoneNumber')
      validators.push(Validators.pattern("^[0-9]{10}$|^[0-9\-]{12}$"));
    if (this.currentQuestion.validations == 'Email')
      validators.push(Validators.pattern('^.+@.+\..+$'));

    if (validators.length > 0) {
      this.textInput.setValidators(validators);
    }
    else
      this.textInput.setValidators(null);

    this.textInput.updateValueAndValidity();

    if (this.currentQuestion.dataTypeName == 'date' && this.currentQuestion.validations.includes('MaxDateToday')) {
      this.maxDate = new Date();
    }
    else {
      this.maxDate = new Date(2050, 1, 1);
    }

    if (this.currentQuestion.dataTypeName == 'date' && this.currentQuestion.validations.includes('MinDate1900')) {
      this.minDate = new Date(1900, 1, 1);
    }
  }

  onMultiPageRadioChanged(event: MatRadioChange, currentQuestion: SurveyQuestion, selectedRadioText: string) {
    if (currentQuestion.questionFieldName == 'PreScreenVaxCardImage'
      || currentQuestion.questionFieldName == 'PreScreenVaxCardImageClearedToReturn') {
      console.log('preshift radio changed', event, currentQuestion.questionFieldName, selectedRadioText);
      this.selectedCardImageOptionText = selectedRadioText;
    }

  }

  onMultiPageDDChanged(event: MatSelectChange, currentQuestion: SurveyQuestion) {
    //, selectedDDText: string
    if (currentQuestion.questionFieldName == 'PreScreenVaxCardImage'
      || currentQuestion.questionFieldName == 'PreScreenVaxCardImageClearedToReturn') {
      console.log('preshift dropdown changed', event, currentQuestion.questionFieldName, event.source.triggerValue);
      this.selectedCardImageOptionText = event.source.triggerValue;
    }
  }

  onRadioChanged(
    event: MatRadioChange,
    primayIdQuestion: SurveyQuestion,
    index: number
  ) {
    console.log(event.value, primayIdQuestion.questionFieldName, index);

    if (index > 0) return; //only run for first question

    this.selectedHospital = event.value;
    this.surveyService
      .getLastSurveyResponse(
        this.surveyId,
        event.value,
        primayIdQuestion.questionFieldName
      )
      .subscribe((response: SurveyResponse[]) => {
        console.log("last taken", response);

        this.questions.forEach((q) => {
          if (primayIdQuestion.questionFieldName != q.questionFieldName) {
            q.answerText = "";
            let answerField = response.find(
              (r) => r.questionFieldName == q.questionFieldName
            );

            if (answerField) {
              if (
                q.dataTypeName == "multioptioninput" ||
                q.dataTypeName == "multioptioninputinteger"
              ) {
                let optionAnswers = answerField.questionAnswer
                  ? answerField.questionAnswer.split("|")
                  : [];
                q.multiTextInputOptions.forEach((option) => {
                  //option.value = "";
                  let findAnswer = optionAnswers.find((oa) =>
                    oa.startsWith(option.name)
                  );
                  option.value =
                    findAnswer && findAnswer.indexOf("undefined") <= 0
                      ? findAnswer.split(":")[1]
                      : "";
                });
              }
              q.answerText = answerField.questionAnswer;
            }
          }
        });
      });
  }

  changeFirstCharToLowerCase(fieldName: string): string {
    return fieldName.charAt(0).toLowerCase() + fieldName.slice(1);
  }

  checkboxSlideChanged(event: MatSlideToggleChange, option: CheckboxOption) {
    this.currentQuestion.answerText = "";

    option.checked = event.checked;

    this.currentQuestion.checkboxOptions.forEach((element) => {
      if (element.checked)
        this.currentQuestion.answerText += element.value + "|";
    });
  }

  onInputOptionChange(
    event: any,
    textOptions: MultiTextInputOption[],
    selQuestionIndex: number
  ) {
    console.log(textOptions);

    let negativeValues = textOptions.filter((o) => +o.value < 0);
    if (negativeValues.length > 0) {
      this.questions[selQuestionIndex].answerText = "";
      return;
    }

    // let anyFilledValues = textOptions.filter(
    //   (o) => !(o.value == null || o.value == "")
    // );
    // if (anyFilledValues.length == 0) {
    //   this.questions[selQuestionIndex].answerText = "";
    //   return;
    // }

    let anyEmptyValues = textOptions.filter(
      (o) => o.value === null || o.value === ""
    );
    //console.log("any empty", anyEmptyValues);
    if (anyEmptyValues.length > 0) {
      this.questions[selQuestionIndex].answerText = "";
      return;
    }

    this.questions[selQuestionIndex].answerText = "some value";
  }

  isFormInvalid() {
    return this.questions
      .filter((q) => q.required == true)
      .some((q) => q.answerText == "");
  }

  get validationErrors() {
    let errorMessage = "";
    this.questions.forEach((q, index) => {
      if (q.answerText == "") {
        errorMessage += index + 1 + ", ";
      }
    });

    return errorMessage.length > 0 ? errorMessage + " Required" : errorMessage;
  }

  openErrorDialog(errorCode, errorMessage) {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '450px',
      data: { ErrorCode: errorCode, ErrorMessage: errorMessage }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      if (result == "continue") {
        if (!navigator.onLine) {
          let transSaveErrorMessage = "Connection Error";
          var onlineErrorMsg = "Unable to determine a result at this time.This is usually the result of an internet connectivity issue.Would you like to submit your answers again or start the screening again?"
          this.openErrorDialog(transSaveErrorMessage, onlineErrorMsg);
        }
        else {
          this.setSelectedIndex(0);
        }
      }
      if (result == "submit") {
        if (!navigator.onLine) {
          let transSaveErrorMessage = "Connection Error";
          var onlineErrorMsg = "Unable to determine a result at this time.This is usually the result of an internet connectivity issue.Would you like to submit your answers again or start the screening again?"
          this.openErrorDialog(transSaveErrorMessage, onlineErrorMsg);
        }
        else {
          this.isLoading = true;
          this.submit();
        }
      }
    });
  }

  async submit() {
    let multiTextQuestions = this.questions.filter(
      (q) =>
        q.dataTypeName == "multioptioninput" ||
        q.dataTypeName == "multioptioninputinteger"
    );
    if (multiTextQuestions) {
      multiTextQuestions.forEach((question) => {
        question.answerText = "";
        question.multiTextInputOptions
          .filter((o) => o.value != "")
          .forEach((option) => {
            question.answerText += option.name + ":" + option.value + "|";
          });
      });
    }

    let saveEntryData: SaveSurveyEntry = new SaveSurveyEntry();
    let authDetails = this.localstorageService.getAuth();
    console.log(authDetails);
    if (authDetails.isAuthenticated) {
      if (authDetails.employeeInfo.employeeId != null) {
        saveEntryData.employeeId = authDetails.employeeInfo.employeeId;
        saveEntryData.corpId = authDetails.employeeInfo.corpId;
      }
    } else {
      saveEntryData.firstName = authDetails.personalInfo.firstName;
      saveEntryData.lastName = authDetails.personalInfo.lastName;
    }

    saveEntryData.authenticated = authDetails.isAuthenticated;
    saveEntryData.corpId = authDetails.employeeInfo.corpId;
    saveEntryData.surveyAppId = this.surveyId;
    saveEntryData.employeeId = authDetails.employeeInfo.employeeId;
    saveEntryData.enteredBy = authDetails.employeeInfo.corpId;

    console.log(authDetails.verificationData.dateOfBirth);
    console.log(
      "DateOfBirth Month = " +
      authDetails.verificationData.dateOfBirth.split("-")[0]
    );
    console.log(
      "DateOfBirth Day = " +
      authDetails.verificationData.dateOfBirth.split("-")[1]
    );

    //MobilePhoneNumber, BirthDate, PersonalEmail, WorkEmail
    //saveEntryData.birthDate = authDetails.verificationData.dateOfBirth;
    saveEntryData.birthDateMonth = parseInt(
      authDetails.verificationData.dateOfBirth.split("-")[0]
    );
    saveEntryData.birthDateDay = parseInt(
      authDetails.verificationData.dateOfBirth.split("-")[1]
    );
    saveEntryData.personalEmail = authDetails.personalInfo.personalEmail;
    saveEntryData.mobilePhoneNumber = authDetails.personalInfo.cellPhone;
    saveEntryData.workEmail = authDetails.verificationData.workEmail;

    saveEntryData.locationOrEventId = '';
    if(this.surveyService.locationOrEvent.event.length > 0){
      saveEntryData.locationOrEventId = this.surveyService.locationOrEvent.event;
    }
    else if(this.surveyService.locationOrEvent.location.length > 0){
      saveEntryData.locationOrEventId = this.surveyService.locationOrEvent.location;
    }

    let answers: Answer[] = [];
    this.questions.forEach((q) => {
      let tempAnswer: Answer = {
        questionFieldName: q.questionFieldName,
        answerText: q.answerText
      };
      if (q.questionFieldName == 'PreScreenVaxCardImage' || q.questionFieldName == 'PreScreenVaxCardImageClearedToReturn') {
        tempAnswer.answerText += '-' + this.selectedCardImageOptionText;
      }
      if (q.questionFieldName == 'CovidExposureTestedPositive') {
        let boosterSymptomQuestion = this.questions.find(q=>q.questionFieldName == 'CovidExposureBoosterSymptoms')
        if(boosterSymptomQuestion && (q.answerText == 'No' && this.isLastPSSResultFail == false)){
          tempAnswer.answerText = 'BoosterNo';
        }
      }
      answers.push(tempAnswer);
      if (q.questionFieldName == 'PreScreenRequiredResultToReport' && q.answerText == 'No') {
        answers.push({
          questionFieldName: 'PreScreenCovidTestInputForm', answerText: 'LastCovidTest8DaysOrMoreYes',
        }); //force it to show not compliant
      }
    });

    saveEntryData.items = answers;

    console.log(saveEntryData);

    this.isSubmitting = true;

    if (this.surveyUrl == "/screening/pre-shift" || this.surveyUrl == "/survey/covidexposure" || this.surveyUrl == "/survey/monkeypox") {

      // save images
      if (this.webCamfiles.length > 0) {
        console.log('saving webCamImages', this.webCamfiles);
        // webcam files are resized in handleImage
        await this.saveWebCampPictureToCloud().toPromise();
      }
      if (this.readerFileDetails !== "") {
        console.log('saving upload Images', this.readerFileDetails);
        //this.readerFileDetails is resized in onSelectFile
        await this.saveUploadImages(this.readerFileDetails).toPromise();
      }
      if (this.covidTestData) {
        console.log('saving covidTestData Images', this.covidTestData);
        await this.cameraService.saveCovidTestData(this.covidTestData).toPromise();
      }
      if (this.surveyUrl == "/screening/pre-shift") {
        this.surveyService.savePreshiftQuestionsAnswer(saveEntryData).subscribe((responseData) => {
          console.log(responseData);
          this.isSubmitting = false;
          this.surveyService.showRedirectTimer = true;
          this.router.navigate(["/screening-report"]);
        },
          (error) => {
            this.handleError(error);
          }
        );
      }
      else if (this.surveyUrl == "/survey/monkeypox") {
        this.surveyService.saveMonkeypoxQuestionsAnswer(saveEntryData).subscribe((responseData) => {
          console.log(responseData);
          this.isSubmitting = false;
          this.formSubmitted = true;
          this.router.navigate(["/monkeypox-report"]);
        },
          (error) => {
            this.handleError(error);
          }
        );
      }
      else {
        this.surveyService.saveCovidExposureQuestionsAnswer(saveEntryData).subscribe((responseData) => {
          // save external covid test
          if (this.externalTestData && this.externalTestData.files.length > 0) {
            this.externalTestData.surveyEntryId = responseData.surveyEntryId;
            this.cameraService.saveExternalCovidTestData(this.externalTestData).subscribe((res) => { console.log(res); });
          }

          console.log(responseData);
          this.isSubmitting = false;
          this.formSubmitted = true;
          this.router.navigate(["/exposure-report"]);
        },
          (error) => {
            this.handleError(error);
          }
        );
      }
    } else {
      if (this.surveyUrl == "/survey/vaxupload") {
        // save images
        if (this.webCamfiles.length > 0) {
          console.log('saving webCamImages', this.webCamfiles);
          // webcam files are resized in handleImage
          await this.saveWebCampPictureToCloud().toPromise();
        }
        if (this.readerFileDetails !== "") {
          console.log('saving upload Images', this.readerFileDetails);
          //this.readerFileDetails is resized in onSelectFile
          await this.saveUploadImages(this.readerFileDetails).toPromise();
        }
      }
      this.surveyService.saveSurveyQuestionsAnswer(saveEntryData).subscribe(
        (responseData) => {
          //success

          console.log(responseData);
          this.isSubmitting = false;
          this.formSubmitted = true;

          if (this.surveyUrl == "/survey/vaxupload") {
            if (this.webCamfiles.length > 0 || this.readerFileDetails !== "") {
              this.router.navigate(["/vax-thank-you"]);
            }
            else {
              this.router.navigate(["/non-vax-thank-you"]);
            }

          }
          else {
            this.router.navigate(["/thank-you"]);
          }
        },
        (error) => {
          console.error(error);
          this.isSubmitting = false;
          if (!navigator.onLine) {
            let transSaveErrorMessage = "Connection Error";
            var onlineErrorMsg = "Unable to determine a result at this time.This is usually the result of an internet connectivity issue.Would you like to submit your answers again or start the screening again?"
            this.openErrorDialog(transSaveErrorMessage, onlineErrorMsg);
          }
          else {
            this.toasterWrapper.showError(JSON.stringify(error));
          }
        }
      );
    }

  }

  private handleError(error: any) {
    console.error(error);
    this.isSubmitting = false;
    if (!navigator.onLine) {
      let transSaveErrorMessage = "Connection Error";
      var onlineErrorMsg = "Unable to determine a result at this time.This is usually the result of an internet connectivity issue.Would you like to submit your answers again or start the screening again?";
      this.openErrorDialog(transSaveErrorMessage, onlineErrorMsg);
    }
    else {
      this.toasterWrapper.showError(JSON.stringify(error));
    }
  }

  private saveWebCampPictureToCloud() {
        return this.cameraService.savePhoto(this.webCamfiles);
  }


}
